module.exports = __webpack_public_path__ + "static/media/Replacement Pump Cassette - only suitable for pH Controller or M3 or M4 Peripods.3747e1ad.webp";